import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Input, Radio, Textarea } from "../../../ui/inputs/Input";

export default function Deducciones({ setTabla, setShow, show }) {
  const [mostrarOtroPorcentaje, setMostrarOtroPorcentaje] = useState(false);

  const codigoRef = useRef();
  const descripcionRef = useRef();

  const salir = () => {
    setShow(false);
    setTabla(0);
  };
  
  const unidadHandler = (e) => {
    if (e.target.id === "unidad5") {
      setMostrarOtroPorcentaje(true);
    } else {
      setMostrarOtroPorcentaje(false);
    }
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Tipo de Deducciones de Pago de Obras</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-4 m-0 p-0">
          <Input label="Código:" ref={codigoRef} />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex gap-2 justify-content-between border-azul rounded">
          <legend className="float-none w-auto m-0">Apliacas a:</legend>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Base Imponible de la Valuación"
              name="deducciones"
              id="deducciones1"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Base Imponible de la Obra"
              name="deducciones"
              id="deducciones2"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Total de la Obra"
              name="deducciones"
              id="deducciones3"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Monto total de la valuacion"
              name="deducciones"
              id="deducciones4"
            />
          </div>
        </fieldset>
        <div className="col-12 m-0 p-0">
          <Textarea
            label="Descripción:"
            style={{ height: 70 }}
            ref={descripcionRef}
          />
        </div>
        <fieldset className="col-12 m-0 mb-2 p-2 d-flex gap-2 justify-content-between border-azul rounded">
          <legend className="float-none w-auto m-0">Unidad Retención</legend>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Porcentaje"
              name="unidad"
              id="unidad1"
              onChange={unidadHandler}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Mil Porciento"
              name="unidad"
              id="unidad2"
              onChange={unidadHandler}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Unidad Tributaria"
              name="unidad"
              id="unidad3"
              onChange={unidadHandler}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Monto Fijo"
              name="unidad"
              id="unidad4"
              onChange={unidadHandler}
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Otro Porcentaje"
              name="unidad"
              id="unidad5"
              onChange={unidadHandler}
            />
          </div>
          <div
            className="col-auto m-0 p-0"
            style={
              !mostrarOtroPorcentaje
                ? { visibility: "hidden" }
                : { visibility: "visible" }
            }
          >
            <Input placeholder="0.00" />
          </div>
        </fieldset>
      </Modal.Body>
    </Modal>
  );
}
